import { Button, Drawer, Icon } from '@components';

const components = {
  drawer: Drawer,
  button: Button,
  icon: Icon
};

Object.entries(components).forEach(([name, component]) => {
  customElements.define(`kabinet-${name}`, component as any);
});
